import { createAction } from 'typesafe-actions';
import * as SHOP from '../constants/Shop';

// Get Shop Info
export const getShopInfoAction = createAction(
  SHOP.GET_SHOP_INFO,
  (resolve) => (params) => resolve({ data: { params } }));

export const getShopInfoCancelledAction = createAction(
  SHOP.GET_SHOP_INFO_CANCELLED,
  (resolve) => () => resolve());

export const getShopInfoFulfilledAction = createAction(
  SHOP.GET_SHOP_INFO_FULFILLED,
  (resolve) => (shopInfo) => resolve({ data: shopInfo }));

export const getShopInfoRejectedAction = createAction(
  SHOP.GET_SHOP_INFO_REJECTED,
  (resolve) => (error) => resolve({ error }));

export const getShopAddressAction = createAction(
  SHOP.GET_SHOP_ADDRESS,
  (resolve) => (params) => resolve({ data: { params } }));

export const getShopAddressCancelledAction = createAction(
  SHOP.GET_SHOP_ADDRESS_CANCELLED,
  (resolve) => () => resolve());

export const getShopAddressFulfilledAction = createAction(
  SHOP.GET_SHOP_ADDRESS_FULFILLED,
  (resolve) => (res) => resolve({ data: { res } }));

export const getShopAddressRejectedAction = createAction(
  SHOP.GET_SHOP_ADDRESS_REJECTED,
  (resolve) => (error) => resolve({ error }));

export const getShopDescriptionAction = createAction(
  SHOP.GET_SHOP_DESCRIPTION,
  (resolve) => (params) => resolve({ data: { params } }));

export const getShopDescriptionCancelledAction = createAction(
  SHOP.GET_SHOP_DESCRIPTION_CANCELLED,
  (resolve) => () => resolve());

export const getShopDescriptionFulfilledAction = createAction(
  SHOP.GET_SHOP_DESCRIPTION_FULFILLED,
  (resolve) => (res) => resolve({ data: { res } }));

export const getShopDescriptionRejectedAction = createAction(
  SHOP.GET_SHOP_DESCRIPTION_REJECTED,
  (resolve) => (error) => resolve({ error }));